/**
 * Application configuration
 */
import { message, SYS_PREFIX } from '@mts-fe/utils';
import { commonStoragePrefix, globSetting, storageShortName } from '@mts/utils/env';
import { inMtsApp } from '@mts/utils/MTSApp';
import { getLocaleStore } from '@/store';

const docEle = document.documentElement;

function updateDeviceTheme() {
  docEle.classList.add(`${SYS_PREFIX}-APP`, `${SYS_PREFIX}-${globSetting.device.toLowerCase()}`);
  inMtsApp && docEle.classList.add('in-mts-app');

  const version = window.navigator.userAgent.match(/(Chrome)\/([0-9]+\.?[0-9]*)/i)?.[2];
  if (version) {
    const v = parseInt(version);
    v < 83 && message.warning('当前浏览器版本过低，请先升级！', 0);
    v < 84 && docEle.classList.add('no-flex-gap');
    v < 88 && docEle.classList.add('no-where-selector');
  }
}

// Initial project configuration
export function initAppConfigStore() {
  updateDeviceTheme();
  // init store
  getLocaleStore().initLocale();

  requestIdleCallback(clearObsoleteStorage);
}

/**
 * As the version continues to iterate, there will be more and more cache keys stored in localStorage.
 * This method is used to delete useless keys
 */
export function clearObsoleteStorage() {
  [localStorage, sessionStorage].forEach((item: Storage) => {
    Object.keys(item).forEach((key) => {
      if (key && key.startsWith(commonStoragePrefix) && !key.startsWith(storageShortName)) {
        item.removeItem(key);
      }
    });
  });
}
